<template>
  <div class="main-license">
    <main>
      <!-- 许可证 -->
      <div class="toolbar license-toolbar"  style="position:relative;padding: 22px;">
        <div class="permit-bar">
          <div v-if="licenseExpireDate.activationID">
            <a-button type="primary" shape="round">激活 ID：{{licenseExpireDate?licenseExpireDate.activationID: '--'}}</a-button>
            <a-button shape="round" style="background-color: #23c343; color: #fff;" v-if="licenseExpireDate.expireDate >= currentDate">许可证有效期至：{{ licenseExpireDate? licenseExpireDate.expireDate : '--' }} </a-button>
            <a-button type="danger" shape="round" v-else>许可证已过期：{{ licenseExpireDate? licenseExpireDate.expireDate : '--' }}</a-button>
            <a-button style="background-color: #ff771c;color:#fff;" shape="round">{{ licenseExpireDate.type == 0?'标准许可证':'浮动许可证' }}</a-button>
          </div>
          <a-button type="danger" shape="round" class="ant-unauthorized" v-else>未许可</a-button>
        </div>
        <div class="btn-group">
          <a-button  type="primary"  @click="handleOpen('激活')" v-if="$IA('system:license:save') && $store.state.user.userInfo.roleType == 1 ">
            导入许可证
          </a-button>
<!--          <a-button type="link" style="color:red" @click="deleteVisible = true"-->
<!--            v-if="licenseExpireDate.activationID != null && $IA('system:license:delete') ">-->
<!--            删除-->
<!--          </a-button>-->
        </div>


        <a-select v-model="orgId" placeholder="部门" style="width: 180px;position:absolute;right: 0px;top: -72px;z-index: 999;"
                  :loading="btnLoad" @change="orgChange" show-search  :filter-option="filterOption">
          <a-select-option  v-for="item in treeData" :value="item.id">{{item.name}}</a-select-option>
        </a-select>

        
      </div>
    </main>

    <!-- 内容 -->
    <div class="permitContent" v-if="licenseExpireDate.activationID != null">
      <div v-for="(L,index) in this.licenseData"   :key="L.type" :class="licenseClass == L.title ?'active license-Content ':''+'license-Content' "  @click="licenseTabCick(L.title)">

      <h2>{{ L.title }}</h2>  

      <p style="color:#4c4c4c">总数：<span style="font-weight:600;color:#447df3;">{{ L.total }} </span>个  &nbsp; 已使用：<span style="font-weight:600;color:#23c343;">{{ L.use }} </span>个</p>

      <a-progress type="circle" :percent="Number(L.percent)" :width="130"
        :strokeColor="getProgressColor(Number(L.percent))">
        <template #format="percent">
          <span :style="'color:' +getProgressColor(Number(L.percent))">{{ percent }}%</span>
        </template>
      </a-progress>

      <!-- 
      <a-button type="link" @click="choicePermit(L.title, L.type)" style="padding: 0px;">
        查看更多>>
      </a-button> -->
      <div class="horizontal">

      </div>
        <div class="underline" v-if="licenseClass == L.title">
        </div>
      </div>
    </div>
    <!-- 缺省图 -->
    <!-- <div v-else class="permitDefault">
      <div class="zt-nodata">
        <span>
          License管理暂无数据,请导入许可证
        </span>
      </div>
    </div> -->

    <!-- 数据表格 -->
    <main style="margin-bottom: 0px;">
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="robotName">
            <a-input-search v-model.trim="pagination.robotName" placeholder="机器人"
                            style="width: 200px; " allow-clear :loading="btnLoad" @input="searchTextChange"
                            @search="searchChange" />
          </a-form-model-item>
          <!--            <a-form-model-item  prop="orgId">-->
          <!--              <a-tree-select-->
          <!--                  allowClear-->
          <!--                  v-model='pagination.orgId'-->
          <!--                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"-->
          <!--                  :tree-data="treeData"-->
          <!--                  placeholder="选择部门"-->
          <!--                  style="width: 200px;"-->
          <!--                  @change="searchChange"-->
          <!--                  tree-default-expand-all-->
          <!--                  :replaceFields="{ title: 'name', key: 'id',value:'id' }"-->
          <!--              >-->
          <!--              </a-tree-select>-->
          <!--            </a-form-model-item>-->
          <a-form-model-item prop="isLicensed" >
            <a-select v-model="pagination.isLicensed" placeholder="许可状态" style="  width: 200px; " allowClear
                      :loading="btnLoad" @change="searchChange">
              <a-select-option :value="0">未许可</a-select-option>
              <a-select-option :value="1">已许可</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item >
            <a-button  @click="resetSearch">重 置</a-button>
          </a-form-model-item>
        </a-form-model>

      </div>
      <a-table :columns="tableColumns" bordered :data-source="tableData" @change="handleTableChange"   :pagination="queryCondition" :loading="tableLoad">
            <template slot="licenseState" slot-scope="text">
                <span v-if="text === 0">
                    <a-tag color="blue">未许可</a-tag>
                </span>
                <span v-if="text === 1">
                    <a-tag color="cyan">已许可</a-tag>
                </span>
        
            </template>
            <template slot="enable" slot-scope="text, record">
              <a-popconfirm
                  title="是否禁用该机器人?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="switchConfirm"
              >
                <a-switch  @change="onChange($event,record)" :checked="text == 1 ? true : false "  />

              </a-popconfirm>
            </template>
        </a-table>
    </main>

    <!-- 许可证模态框 -->
<!--    <a-modal centered title="激活" :visible="modalVisible" :closable="closableReset" :confirm-loading="submitLoad" width="700px"-->
<!--      :dialog-style="{ top: '-50px' }" footer @cancel="resetOpen" :maskClosable="false">-->
<!--      &lt;!&ndash; 激活 &ndash;&gt;-->
<!--      <div>-->
<!--        <a-steps :current="current">-->
<!--          <a-step v-for="item in steps" :key="item.title">-->
<!--            <template slot="title">-->
<!--              {{ item.title }}-->
<!--            </template>-->
<!--          </a-step>-->
<!--        </a-steps>-->
<!--        <a-spin :spinning="submitLoad">-->
<!--          <div class="steps-content">-->

<!--            <div v-if="steps[current].title == '申请许可证文件'" class="steps-apply">-->
<!--              <div class="steps-tips">-->
<!--                <h3>Tips: 如何申请许可证文件?</h3>-->
<!--                <P><span>①</span> 截图或拍照保存二维码图片</P>-->
<!--                <P><span>②</span> 向管理员申请许可证文件并保存至电脑</P>-->

<!--                <p>注: 如已加载出的设备相关信息不符合预期，可进行手动刷新</p>-->
<!--              </div>-->
<!--              <a-button type="primary" icon="redo" @click="refreshQr">刷新</a-button>-->

<!--              <div class="qrcode" ref="qrCodeUrl" id="qrcodeId"></div>-->

<!--            </div>-->

<!--            <div v-if="steps[current].title == '上传许可证文件'" class="steps-upload">-->
<!--              <a-upload-dragger name="file" :file-list="fileList" :remove="handleRemove" accept='.lic' :multiple="true"-->
<!--                :before-upload="beforeUpload" @change="handleChange" :showUploadList="false">-->
<!--                <p class="ant-upload-drag-icon">-->
<!--                  <a-icon type="file" v-if="this.fileList.length == 1" />-->
<!--                  <a-icon type="inbox" v-else />-->
<!--                </p>-->

<!--                <p class="ant-upload-text" style="color:#769df1">-->

<!--                  {{ this.fileList.length == 1 ? this.fileNmae : '点击上传许可证文件，或将文件拖拽到此处' }}-->
<!--                </p>-->
<!--                <p class="ant-upload-hint">-->
<!--                  {{ this.fileList.length == 1 ? '重新选择' : '支持后缀lic' }}-->
<!--                </p>-->
<!--              </a-upload-dragger>-->
<!--            </div>-->

<!--            <div v-if="steps[current].title == '激活许可证文件'" class="steps-activation">-->
<!--              &lt;!&ndash; <div>-->
<!--              <img src="../assets/images/ac_succeeded.png" alt="">-->
<!--              <h2>激活成功!</h2>-->
<!--              <p>恭喜,您已成功激活许可证文件</p>-->
<!--            </div> &ndash;&gt;-->
<!--              <div>-->
<!--                <img src="../../assets/images/ac_succeeded.png" alt="">-->
<!--                <h2>激活成功!</h2>-->
<!--                <p>恭喜,您已成功激活许可证文件</p>-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->
<!--        </a-spin>-->

<!--        <div class="steps-action">-->
<!--          <a-button v-if="current < steps.length - 1 && current == 0" type="primary" @click="next">-->
<!--            已有许可证文件,下一步-->
<!--          </a-button>-->

<!--          <a-button v-if="current == 2" style="margin-left: 8px" @click="prev">-->
<!--            完成-->
<!--          </a-button>-->

<!--          <a-button v-if="current == 1" :loading="uploading" :disabled="fileList.length === 0" style="margin-left: 8px"-->
<!--            @click="handleUpload">-->
<!--            导入并激活-->
<!--          </a-button>-->

<!--          <a-button v-if="current > 0 && current == 1" style="margin-left: 8px" @click="back">-->
<!--            上一步-->
<!--          </a-button>-->

<!--        </div>-->
<!--      </div>-->
<!--    </a-modal>-->

    <!-- 删除许可证 -->
    <a-modal centered title="删除许可证" :visible="deleteVisible" :confirm-loading="submitLoad" width="700px"
      @cancel="deleteVisible = false" @ok="handleOk('deptForm')" :dialog-style="{ top: '-150px' }" :maskClosable="false">
      <a-alert message="确定继续吗？" description="* 此操作将删除许可." type="warning" show-icon />
    </a-modal>

  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
// 引入许可证激活组件
import license from '@/components/common/License'
import {notification} from "ant-design-vue";
export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      submitLoad: false,
      uploading: false,
      modalTitle: '',
      formLayout:"inline",
      pagCurrent:{},
      // 弹出框显隐
      modalVisible: false,
      deleteVisible: false,

      // 步骤条
      current: 0,
      steps: [
        {
          title: '申请许可证文件',
        },
        {
          title: '上传许可证文件',
        },
        {
          title: '激活许可证文件',
        },
      ],

      // 许可证数据
      licenseData: [],

      // 当前时间
      currentDate: '',

      // 许可证列表
      licenseExpireDate: "",

      // 文件上传
      fileList: [],

      // 文件名称
      fileNmae: '',

      licenseType:1,

      licenseClass:"",

      tableData:[],
      pagination: {
          robotName: "",
          isLicensed:undefined,
          pageSize: 10,
          pageNo: 1,
          current: 1,
          total: 0,
          type:0,
          orgId:'',
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      queryCondition: {}, 
      delivery:false,
      tableColumns: [
        {
          title: '机器人',
          dataIndex: 'robotName',
          key: 'robotName',
          ellipsis: true,
          
        },
        {
          title: '计算机',
          key: 'machineName',
          dataIndex: 'machineName',
          ellipsis: true,
        },
        {
          title: '账户',
          key: 'robotUserName',
          dataIndex: 'robotUserName',
          ellipsis: true,
        },
        {
          title: '部门',
          key: 'orgName',
          dataIndex: 'orgName',
          ellipsis: true,
        },
        {
          title: '许可',
          key: 'isLicensed',
          dataIndex: 'isLicensed',
          scopedSlots: { customRender: "licenseState" },
        },
        // {
        //   title: '活动',
        //   key: 'enable',
        //   dataIndex: 'enable',
        //   scopedSlots: { customRender: "enable" },
        // },
      ],
      closableReset:true,

      activityChecked:false,
      activityData:{},


      // 表格搜索
      treeData:[],  // 部门列表
      orgId:undefined,
    };
  },
  methods: {
    // 搜索
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    // 表格字段 气泡确认框
    switchConfirm(){
      if (this.activityChecked) {
       this.switchChange(this.activityData,'/license/enable')
      }else{
       this.switchChange(this.activityData,'/license/disable')
      }
    },
    // 表格 活动监听字段更新
    onChange(checked,record) {
      this.activityChecked = checked
      this.activityData = record
    },
    // 部门下拉框
    allorgList() {
      this.axios
          .post("/org/findParentOrg",)
          .then((res) => {
            if (res.code === 200) {
              this.treeData = res.data;
            }

          })
          .catch((err) => {
            console.log(err);
          });
    },
    switchChange(data,api){
      this.axios
        .post(api,{robotId:data.robotId,robotName:data.robotName})
        .then((res) => {
          if (res.code == 200) {
            this.handleTableChange(this.pagCurrent);
            notification.success({
              message: res.message,
              duration: 3,
              customClass: "batch-import",
            })
          } 
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 选择颜色配置
    getProgressColor(successPercent) {
      let color = ''
      if (successPercent < 1) {
        color = '#007acc'
      } else if (successPercent < 51) {
        color = '#16d46b'
      } else if (successPercent < 100) {
        color = '#fcc72b'
      } else {
        color = '#dd001b'
      }
      return color
    },

    // 选择许可
    choicePermit(value, type) {
      let licenseFor = {
        title: value,
        type: type
      }
      this.$emit("open", licenseFor, 'license');
    },

    // 生成二维码
    creatQrCode() {
      this.submitLoad = true;
      this.axios
        .post('/license/getLicenseInfo')
        .then((res) => {
          if (res.code == 200) {
            this.submitLoad = false
            let obj = JSON.stringify(res.data)
            setTimeout(() => {
              new QRCode(this.$refs.qrCodeUrl, {
                text: obj,
                width: 260,
                height: 260,
                colorDark: '#000000',
                colorLight: '#ffffff',
                render: "canvas",
                correctLevel: QRCode.CorrectLevel.L,
              })
              document.getElementById("qrcodeId").title = ''
            }, 0)
          }
        })
        .catch((err) => {
          this.submitLoad = false
          console.log(err);
        });
    },

    // 刷新二维码
    refreshQr() {
      this.creatQrCode()
      this.$refs.qrCodeUrl.innerHTML = ''
    },

    // 激活许可证-下一步
    next() {
      this.current++;
    },

    // 激活许可证-完成
    prev() {
      this.current = 0
      this.modalVisible = false
      this.licenseAjax()
    },

    // 激活许可证-上一步
    back() {
      if (this.current == 1) {
        this.fileList = [];
        this.creatQrCode();
      }
      this.current--;
    },

    // 许可模态框 - 打开
    handleOpen(title, data) {
      license({modalVisible:true,closableReset:true});  // 许可证弹出框
    },
    
    // 许可证模态框关闭
    resetOpen() {
      if (this.modalTitle  == '删除') {
        this.modalVisible = true;
      }else{
        this.modalVisible = false;
        if (this.current == 0) {
        this.$refs.qrCodeUrl.innerHTML = ''
        }
        this.fileList = [];
        this.current = 0
      }
    },

    // 监听文件上传
    handleChange(data) {
      this.fileNmae = data.file.name
    },

    // 移出文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },

    // 判断是否上传文件
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      //限制文件只能上传一个
      this.fileList = this.fileList.slice(-1);
      return false;
    },

    // 上传文件
    handleUpload() {
      const { fileList } = this;
      const formData = new FormData();
      fileList.forEach(file => {
        formData.append('file', file);
      });
      this.uploading = true;

      this.axios
        .post('/license/save', formData)
        .then((res) => {
          if (res.code == 200) {
            this.fileList = [];
            this.current = 2
            this.uploading = false;
          } else {
            this.uploading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //删除-确认模态框
    handleOk() {
      this.submitLoad = true 
      this.axios
        .post('license/delete')
        .then((res) => {
          this.deleteVisible = false
          if (res.code == 200) {
            this.submitLoad = false
            this.handleOpen('删除')
            this.closableReset = false
            this.licenseAjax()
          }
          })
        .catch((err) => {
          this.submitLoad = false
          console.log(err); 
        });

    },

    // 切换列表
    licenseTabCick(title){
      this.licenseClass =  title
      switch (title) {
        case '无人值守':
          this.pagination.type = 0
          break;
        case '有人值守':
          this.pagination.type = 1
          break;
        case '设计器':
          this.pagination.type = 2
          break;
      }
      this.searchChange()
    },
    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    orgChange(val){
      this.pagination.orgId = this.orgId
      this.searchChange()
      this.licenseAjax()
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination : this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
          .post("/license/findPageByType",this.$qs.stringify(this.queryCondition))
          .then((res) => {
                this.tableLoad = false;
              if (res.code === 200) {
                this.tableData = res.data ? res.data.records: [];
                this.queryCondition.total = res.data ? res.data.total : 0;
              }
          })
          .catch((err) => {
              console.log(err);
              this.tableLoad = false;
          });
    },
    // 请求License
    licenseAjax() {
      this.axios
        .post('/license/findPage',{orgId:this.orgId})
        .then((res) => {
          if (res.code == 200) {
            this.licenseExpireDate = res.data ? res.data[3] : ""
            console.log( this.licenseExpireDate)
            let arrayObject = []
            res.data.splice(0, 3).map(function (value, index, array) {
              arrayObject = arrayObject.concat(value);
            });
            this.licenseData = arrayObject
            this.currentDate = this.$moment(new Date()).add('year', 0).format("YYYY-MM-DD")
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  beforeMount() {
    // this.orgId = this.$store.state.user.userInfo.orgId
    // this.pagination.orgId = this.$store.state.user.userInfo.orgId
    this.licenseTabCick()
    this.licenseAjax()
    this.allorgList()
    this.licenseClass = '无人值守'
    // 判断许可证是否到期
    if ( JSON.parse(this.$cookies.get('licenseState')) == false ) {
      license({modalVisible:true,closableReset:false});  // 许可证弹出框
    }
  },
};
</script>
<style lang="scss" scoped>
.main-license {



  main {

    margin: 16px 0;
    background-color: #fff;
    border-radius: 2px;
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
      .permit-bar{
       ::v-deep .ant-btn{
          border-radius: 32px;
          margin-right: 15px;
        }
        .ant-unauthorized{
          background-color: #fff;
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }
  }

  .permitContent {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;

    .license-Content {
      background-color: #fff;
      transition: 0.3s;
      // margin: 20px 8px 0px 8px;
      // border: 1px solid #eee;
      // box-shadow: 0 2px 4px -1px rgb(0 0 0 / 10%), 0 4px 5px 0 rgb(0 0 0 / 7%), 0 1px 10px 0 rgb(0 0 0 / 6%);
      width: calc(20% - 16px);
      min-height: 270px;
      padding: 15px;
      position: relative;
      cursor: pointer;
      opacity: 0.6;

      h2 {
        color: #9fbcf8;
        font-weight: 600;
      }

      .ant-progress {
        padding-left: calc(50% - 63px);
        padding-top: calc(50% - 130px);
        width: calc(50% + 63px);
      }

      .license-desc {
        font-size: 13px;
        font-weight: 700;
        margin: 2.5em 0 1.8em 0;
        color: #7b848a;
      } 
    }
    .license-Content:nth-child(2) .horizontal{ 
        width: 1px;
        height: 190px;
        display: inline-block;
        background-color: #e7ebf3;
        position: absolute;
        left: 0px;
        top: 44px;
    }
    .license-Content:nth-child(3) .horizontal{ 
        width: 1px;
        height: 190px;
        display: inline-block;
        background-color: #e7ebf3;
        position: absolute;
        left: 0px;
        top: 44px;
    }
    .underline{
        width: 220px;
        height: 3px;
        display: inline-block;
        background-color: #3373f2;
        position:absolute;
        bottom: -1px;
        left: 50px;
      }
    .active{
      h2{
        color: #5788f2;
        font-weight: 600;
      }
      opacity: 1;
    }
  }

  .permitDefault {
    width: 99%;
    height: 600px;
    margin: 16px 8px 0px 8px;
    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 10%), 0 4px 5px 0 rgb(0 0 0 / 7%), 0 1px 10px 0 rgb(0 0 0 / 6%);
    border-radius: 4px;
    padding-top: 100px;
    background-color: #fff;

    .zt-nodata {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      background: url('../../assets/images/no_data.png') no-repeat;
      height: 300px;
      background-position: center;
    }
  }


}

::v-deep .ant-progress-text {
  font-size: 25px;
  font-weight: 600;
}


.steps-content {
  margin-top: 10px;

  .steps-apply {
    .steps-tips {
      font-size: 13px;
      font-weight: 600;

      h3 {
        font-weight: 600;
        font-size: 13px;
      }

      p {
        margin: 0px;
      }

      p:nth-child(4) {
        color: #909090;
        margin-top: 15px;
        font-size: 12px;
      }
    }

    .qrcode {
      margin: 20px 0 50px 200px;
    }

    .ant-btn {
      position: absolute;
      right: 20px;
      margin-top: -30px;
    }
  }

  ::v-deep .steps-upload {
    width: 410px;
    margin-left: 125px;
    padding: 40px 0 50px 0;

    .ant-upload {
      height: 280px;
    }


  }

  .steps-activation {
    div {
      text-align: center;
      margin: 50px 0 50px 0;

      img {
        margin-bottom: 2em;
      }

    }
  }
}

.steps-action {
  border-top: 1px #d7dde4 solid;
  padding: 15px 0 20px 0;
  text-align: right;
}
</style>







